/**
 * @generated SignedSource<<62f222b2fc39df0107881ffc23f1aa01>>
 * @relayHash 7af55a47536f172e0db28a589673fb33
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID 7af55a47536f172e0db28a589673fb33

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "values"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "values",
        "variableName": "values"
      }
    ],
    "kind": "ScalarField",
    "name": "checkEmailUnicity",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useCheckEmailUnicityQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useCheckEmailUnicityQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "7af55a47536f172e0db28a589673fb33",
    "metadata": {},
    "name": "useCheckEmailUnicityQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

node.hash = "d32ba8faa87e8341f8ac5faf073b25ce";

export default node;
